import { render, staticRenderFns } from "./FiltersMenu.vue?vue&type=template&id=0f06d260"
import script from "./FiltersMenu.vue?vue&type=script&lang=js"
export * from "./FiltersMenu.vue?vue&type=script&lang=js"
import style0 from "./FiltersMenu.vue?vue&type=style&index=0&id=0f06d260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports